export default __webpack_public_path__ + "static/media/lotesselector.22385649.jpg";